<template>
    <article class="product-list-item card" :data-testing="item.variation.id">
        <div class="card-body">
            <div :class="paddingClasses" :style="paddingInlineStyles">
                <div class="product-image-wrapper">
                    <slot name="item-image">
                        <a :href="item | itemURL(urlWithVariationId)">
                            <lazy-img
                                picture-class="product-image"
                                :image-url="categoryVariationImages.urlMiddle"
                                :alt="item.texts.name1"
                                :title="item.texts.name1">
                            </lazy-img>
                        </a>
                    </slot>
                </div>

                <slot name="store-special">
                    <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                        :store-special="storeSpecial"
                                        :recommended-retail-price="item.prices.rrp"
                                        :variation-retail-price="item.prices.default"
                                        :special-offer-price="item.prices.specialOffer"
                                        :decimal-count="decimalCount"
                                        :bundle-type="item.variation.bundleType"
                                        :item-type="item.item.itemType">
                    </item-store-special>
                </slot>


                <!-- ITEM DETAILS -->
                <slot name="item-details">
                    <div class="product-info">
                        <a :href="item | itemURL(urlWithVariationId)" class="product-name">
                            {{ item | itemName }}<!--
                        --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                        </a>

                        <slot name="before-prices"></slot>

                        <template v-if="userData !== null && b2bClassArray.includes(userData.classId.toString())">
                            <div class="product-price" :class="{'product-price--sale': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value}">
                                <template v-if="item.item.itemType === 'set'">
                                    {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}*
                                </template>
                                    <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                        {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}*
                                </template>
                                <template v-else>
                                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}*
                                </template>

                                <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                    <span class="product-price--uvp" v-if="item.prices.specialOffer">
                                        {{ item.prices.default.unitPrice.formatted}}
                                    </span>
                                    <span class="product-price--uvp" v-else>
                                        {{ item.prices.rrp.unitPrice.formatted }}
                                    </span>
                                </template>

                            </div>
                        </template>
                        <template v-else>
                            <p class="hidden-price-hint hidden-price-hint--category">Verkauf nur an gewerbliche Kunden. Preise sichtbar nach Anmeldung</p>
                        </template>
                        <slot name="after-prices"></slot>

                        <!-- <add-to-basket
                                data-testing="item-add-to-basket"
                                :variation-id="item.variation.id"
                                :is-salable="!!item.filter && item.filter.isSalable"
                                :has-children="!!item.item && item.item.salableVariationCount > 1"
                                :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                :minimum-quantity="item.variation.minimumOrderQuantity"
                                :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                :has-order-properties="item.hasOrderProperties"
                                :use-large-scale="false"
                                :show-quantity="false"
                                :item-url="item | itemURL(urlWithVariationId)"
                                :has-price="item | hasItemDefaultPrice"
                                :item-type="item.item.itemType">
                        </add-to-basket> -->

                        <!-- <div class="product-price--vat">
                            * <span v-if="showNetPrices">{{ $translate("Ceres::Template.itemExclVAT") }}</span>
                            <span v-else>{{ $translate("Ceres::Template.itemInclVAT") }}</span>
                            {{ $translate("Ceres::Template.itemExclusive") }}
                            <a v-if="$ceres.config.global.shippingCostsCategoryId > 0" data-toggle="modal" href="#shippingscosts" class="text-appearance" :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                            <a v-else :title="$translate('Ceres::Template.itemShippingCosts')">{{ $translate("Ceres::Template.itemShippingCosts") }}</a>
                        </div> -->
                    </div>
                </slot>
                <!-- ./ITEM DETAILS  -->
            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import ItemStoreSpecial from "~/app/components/itemList/ItemStoreSpecial.vue";

export default {
    components: {
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        b2bClassArray(){
            return App.b2bCustomerClassArr.split(",");
        },

        item()
        {
            return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices,
            userData: state => state.user.userData
        }),

        categoryVariationImages(){
            if ( this.item.images.variation.length > 0) {
                return this.item.images.variation[0]
            }

            return this.item.images.all[0]
        }
    }
}
</script>
